<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        {{ $t('shipmentErrors.title') }}
        <v-spacer />
        <v-select
            v-model="reasonFilter"
            :items="errorReasonOptions"
            :label="$t('shipmentErrors.filterByReason')"
            clearable
            dense
            outlined
            hide-details
            style="max-width: 260px"
            @change="onFilterChange"
        />
      </v-card-title>

      <v-data-table
          :headers="headers"
          :items="shipments"
          :options.sync="options"
          :server-items-length="totalCount"
          :loading="loading"
          :footer-props="{ itemsPerPageOptions: [10, 20, 50] }"
          @update:options="fetchShipments"
      >
        <template #item.errorReason="{ item }">
          <v-chip small :color="reasonColor(item.errorReason)" text-color="white">
            {{ reasonLabel(item.errorReason) }}
          </v-chip>
        </template>

        <template #item.updateDate="{ item }">
          {{ formatDate(item.updateDate) }}
        </template>

        <template #no-data>
          <div class="text-center py-6">
            {{ $t('shipmentErrors.noData') }}
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {containerTrackingErrorService} from "../../services/containerTrackingError.service";

export default {
  name: "ContainerErrorsPage",

  data() {
    return {
      shipments: [],
      totalCount: 0,
      loading: false,
      reasonFilter: null,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: [],
        sortDesc: [],
      },
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t("shipmentErrors.headers.documentNumber"),
          value: "documentNumber",
        },
        {
          text: this.$t("shipmentErrors.headers.trackingType"),
          value: "trackingType",
          sortable: false,
        },
        {
          text: this.$t("shipmentErrors.headers.reason"),
          value: "errorReason",
        },
        {
          text: this.$t("shipmentErrors.headers.message"),
          value: "errorMessage",
        },
        {
          text: this.$t("shipmentErrors.headers.lastUpdated"),
          value: "updateDate",
        },
      ];
    },

    errorReasonOptions() {
      return [
        {
          text: this.$t("shipmentErrors.reasons.carrierNotMapped"),
          value: "CARRIER_NOT_MAPPED",
        },
        {
          text: this.$t("shipmentErrors.reasons.polMismatch"),
          value: "POL_MISMATCH",
        },
        {
          text: this.$t("shipmentErrors.reasons.noCarrierResponse"),
          value: "NO_CARRIER_RESPONSE",
        },
        {
          text: this.$t("shipmentErrors.reasons.unknown"),
          value: "UNKNOWN",
        },
      ];
    },
  },

  methods: {
    fetchShipments() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const offset = (page - 1) * itemsPerPage;
      const limit = itemsPerPage;

      const filter = { status: "ERROR" };
      if (this.reasonFilter) {
        filter.errorReason = this.reasonFilter;
      }

      const sortingList = sortBy.map((column, i) => ({
        column,
        direction: sortDesc[i] ? "DESC" : "ASC",
      }));

      containerTrackingErrorService
          .browse(offset, limit, filter, sortingList)
          .then((response) => {
            this.shipments = response.resultList;
            this.totalCount = response.totalCount;
          })
          .catch((err) => {
            console.error(this.$t("shipmentErrors.errors.loadFailed"), err);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onFilterChange() {
      this.options.page = 1;
      this.fetchShipments();
    },

    reasonLabel(reason) {
      const found = this.errorReasonOptions.find((o) => o.value === reason);
      return found ? found.text : reason;
    },

    reasonColor(reason) {
      switch (reason) {
        case "CARRIER_NOT_MAPPED":
          return "orange";
        case "POL_MISMATCH":
          return "red";
        case "NO_CARRIER_RESPONSE":
          return "grey";
        default:
          return "blue-grey";
      }
    },

    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString();
    },
  },
};
</script>